// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-welcome-small-screen-container {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 1fr 30px min-content;
}
.auth-welcome-small-screen-container .panel-1 {
  grid-row: 1/3;
  grid-column: 1;
  z-index: 1;
  position: relative;
}
.auth-welcome-small-screen-container .panel-1 .content {
  width: 100%;
  height: 100%;
  position: absolute;
  padding: 25px 15px;
  background-color: transparent;
  top: 0px;
  left: 0;
  display: grid;
  grid-template-columns: 100%;
  grid-auto-flow: row;
  grid-auto-rows: min-content;
  row-gap: 15px;
}
.auth-welcome-small-screen-container .panel-1 .content .myao-logo {
  width: 76px;
  height: 22px;
}
.auth-welcome-small-screen-container .panel-1 .content .description p {
  margin: 0;
  font-size: var(--font-line-height-extra-large);
  font-weight: var(--font-weight-regular);
  color: var(--mi-white-color);
}
.auth-welcome-small-screen-container .panel-1 .content .description p span {
  font-weight: var(--font-weight-bold);
}
.auth-welcome-small-screen-container .panel-1 ion-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.auth-welcome-small-screen-container .overlap {
  grid-row: 2;
  grid-column: 1;
  z-index: 2;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  background-color: var(--mi-white-color);
}
.auth-welcome-small-screen-container .panel-2 {
  grid-row: 3;
  grid-column: 1;
  height: calc(100vh - 180px);
  background-color: var(--mi-white-color);
  position: relative;
}
.auth-welcome-small-screen-container .panel-2 ion-content {
  --background: transparent;
  --padding-start: 15px;
  --padding-end: 15px;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.auth-welcome-small-screen-container .panel-2 ion-content app-auth-buttons ::ng-deep .auth-buttons-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: normal;
  padding-bottom: 30px;
}
.auth-welcome-small-screen-container .panel-2 ion-content app-auth-buttons ::ng-deep .auth-buttons-container .info-text-container {
  padding-bottom: 20px;
}
.auth-welcome-small-screen-container .panel-2 ion-content app-auth-buttons ::ng-deep .auth-buttons-container .buttons-container {
  row-gap: 10px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
